import React, { Component, useState } from "react";
import Navbar from "../../../shared/components/navbar";

import Sidebar from "../../../shared/components/sidebar";
import MainLayout from "../../../shared/components/MainLayout";

const messageWarning1 =
  "Non è possibile aggiornare perché il formato della mail esiste già";
const messageWarning2 =
  "Non è possibile aggiornare perché i parametri inseriti sono già stati salvati";

const Dashboard = () => (
  <MainLayout>
    <div className="flex flex-col items-center justify-center w-full">
      <iframe
        className="p-4"
        width="100%"
        height="1600px"
        src="https://datastudio.google.com/embed/reporting/22196b6a-8a06-43c8-92a5-587931de3ce2/page/PncAD"
        allowFullScreen
      />
    </div>
  </MainLayout>
);

export default Dashboard;
